import styled from '@emotion/styled';

export const Column = styled.div`
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
